/* istanbul ignore file */
import React, { ReactNode, useState, ReactElement, useContext } from "react";
import classnames from "classnames";
import NavigationList from "../../../navigation/NavigationList";
import { AppDataContext } from "../../../navigation/appdata-context";
import { Footer } from "adviesbox-shared";

type DrawerProps = {
  children: ReactNode;
};

const Drawer = (props: DrawerProps): ReactElement => {
  const { children } = props;
  const [collapsed, setcollapsed] = useState(false);
  const { lastMutationDate } = useContext(AppDataContext);

  return (
    <div className="drawer-wrapper">
      <div className={classnames("drawer-panel", { collapsed })}>
        <NavigationList collapsed={collapsed} collapse={(): void => setcollapsed(!collapsed)} />
      </div>
      <div className="drawer-content">{children}</div>
      <Footer lastMutationDate={lastMutationDate} />
    </div>
  );
};

Drawer.displayName = "Drawer";

export default Drawer;
